import { MyContentContainer } from 'modules/MyContent'
import React from 'react'

type Props = {}

const MyContent = (props: Props) => {
  return (
    <MyContentContainer />
  )
}



export default MyContent